export default __webpack_public_path__ + "assets/front/scss/notice-complete.766cd37a8bab8d3340c6d9ecfaebeef9.css";